var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashpink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1146_17332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5385 6.88467V6.34621C14.5385 5.75144 14.0563 5.26929 13.4615 5.26929H10.7692C10.1775 5.27655 9.69957 5.75448 9.69231 6.34621V6.88467H7V7.42313H7.53846L8.08231 17.6733C8.12871 18.2643 8.61764 18.7226 9.21038 18.7308H15.0204C15.6131 18.7226 16.1021 18.2643 16.1485 17.6733L16.6923 7.42313H17.2308V6.88467H14.5385ZM13.4615 5.80775C13.7589 5.80775 14 6.04883 14 6.34621V6.88467H10.2308V6.34621C10.2308 6.04883 10.4718 5.80775 10.7692 5.80775H13.4615ZM15.6127 17.6377C15.5843 17.946 15.3298 18.1843 15.0204 18.1924H9.21038C8.90095 18.1843 8.64648 17.946 8.61808 17.6377L8.07692 7.42313H16.1538L15.6127 17.6377ZM12.3846 17.1154V8.50006H11.8462V17.1154H12.3846ZM10.7692 17.1154L10.2308 8.50006H9.69231L10.2308 17.1154H10.7692ZM14.5358 8.50006H13.9865L13.4615 17.1154H14L14.5358 8.50006Z",
    fill: "#FF69B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1146_17332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.2308,
    height: 14,
    fill: "white",
    transform: "translate(7 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashpink);
export default __webpack_public_path__ + "static/media/trashpink.d70b795512dfe8426ecc6153d963257d.svg";
export { ForwardRef as ReactComponent };